exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-page .l-scroll .l-scroll-content{background:none}.create-page .l-tab-scroll-bar{display:none}.create-page .l-tab{margin-bottom:5px;width:100%;overflow-x:auto;overflow-y:hidden}.create-page .l-tab .l-tab-list{display:block;white-space:nowrap}.create-page .l-tab .l-tab-list .l-tab-item{display:inline-block;margin:0 10px;white-space:nowrap}.create-page .create-context{padding-top:10px}.create-page .pullup-wrapper{display:none}", ""]);

// exports
